module.exports = __webpack_public_path__ + "img/marker_forest.7825bad4.svg";